export const claimFileType = {
  DECLARATION_OF_RECIPIENT: 'declaration_of_recipient',
  TRACKING_SCREENSHOT: 'tracking_screenshot',
  INVOICE_DOCUMENT: 'invoice_document',
  PICTURE_OF_DAMAGE: 'picture_of_damage',
  PICTURE_OF_MISSING_ITEM: 'picture_of_missing_item',
};
